<template>
  <div>
    <pre>{{myObject}}</pre>
    <pre>{{currentStepIdx}}</pre>
    <v-stepper v-model="currentStepIdx">
      <v-stepper-header>
        <v-stepper-step v-for="(step, idx) in steps" :key="idx" :step="idx+1">{{step.title}}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content v-for="(step, idx) in steps" :key="idx" :step="idx+1">
          <v-card outlined>
            <v-card-text>
              <component :is="step.component" v-model="myObject" />
            </v-card-text>
            <v-card-actions>
              <v-btn :disabled="!canPrevStep" text @click="prevStep()">prev</v-btn>
              <v-btn :disabled="!canNextStep" text @click="nextStep()">next</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>


<script>
import EditMessage from "./EditMessage";
import EditValue from "./EditValue";

export default {
  data() {
    return {
      myObject: {
        message: "this is my object",
        value: 10
      },
      currentStepIdx: 1,
      steps: [
        {
          title: "edit message",
          component: EditMessage
        },
        {
          title: "edit value",
          component: EditValue
        },
        {
          title: "edit message",
          component: EditMessage
        }
      ]
    };
  },
  computed: {
    canPrevStep() {
      return this.currentStepIdx > 1;
    },
    canNextStep() {
      return this.currentStepIdx < this.steps.length;
    }
  },
  methods: {
    nextStep() {
      if (this.currentStepIdx < this.steps.length) this.currentStepIdx++;
    },
    prevStep() {
      if (this.currentStepIdx > 1) this.currentStepIdx--;
    }
  }
};
</script>